export { GetClubsDocument } from './GetClubs.query.generated';
